document.addEventListener('DOMContentLoaded', () => {

  const strikeElements = document.querySelectorAll('.js-strike-through');
  let viewportHeight = window.innerHeight;

  if (strikeElements.length > 0) {
      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  const elementTopPosition = entry.target.getBoundingClientRect().top;
                  if (viewportHeight - elementTopPosition >= 0) {
                      entry.target.classList.add('c-strike-through');
                  }
              }
          });
      }, {
          root: null
      });

      strikeElements.forEach(element => {
          observer.observe(element);
      });

      window.addEventListener('resize', () => {
          viewportHeight = window.innerHeight;
      });
  }

});



// WEBPACK FOOTER //
// ./src/scripts/modules/strikeThrough.js